module.exports = __webpack_public_path__ + "static/media/cover_ger_9_10.fd8283c9.jpg";